module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgd2lkdGg9IjUwcHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDUwIDUwIj4NCgk8bGluZSB4MT0iNCIgeTE9IjQiIHgyPSI0NiIgeTI9IjQ2Ii8+DQoJPGxpbmUgeDE9IjQ2IiB5MT0iNCIgeDI9IjQiIHkyPSI0NiIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-styles/icons/stroke/cross.svg
// module id = ./node_modules/graphcool-styles/icons/stroke/cross.svg
// module chunks = 0 1